export const GLOBAL_ERROR_TYPE = {
  InactiveUser: 'inactiveUser',
  PaymentRequired: 'paymentRequired',
} as const;

export type GlobalErrorType = (typeof GLOBAL_ERROR_TYPE)[keyof typeof GLOBAL_ERROR_TYPE];
